export const uniquePosts = (posts) => posts.reduce((unique, post) => {
  if (!unique.some((p) => p.foreign_id === post.foreign_id)) {
    unique.push(post);
  }
  return unique;
}, []);
